/* eslint-disable no-extra-boolean-cast */
(function () {

    angular.module('tmx-app').controller('dashboardCtrl', ['$scope','$mdDialog', 'DashboardService', 'tmxUtility','TMX_FINANCE_CONSTANTS','BranchService','cacheStore','APP_CONSTANTS','menu',

        function DashboardCtrl($scope, $mdDialog, DashboardService, tmxUtility,TMX_FINANCE_CONSTANTS,BranchService,cacheStore,APP_CONSTANTS,menu) {
            var vm = this;
            vm.EntityName = "Dashboard";
            vm.tenant = 'dev';
            vm.checkPermission = tmxUtility.checkPermission;
            var LoggedInUserConfigurations =  cacheStore.get("Configurations");	
            vm.checkDashboardTypeAndPermission = checkDashboardTypeAndPermission;
            vm.dashboardType = "";
            vm.showAccountAppSummary = true;
            vm.menu=menu;            
            //#region FUNCTIONS AND VARIABLES FOR POWER BI USAGE /////////////////////////////////////////

            // vm.entity=$scope.entity;
            // vm.submitted=$scope.submitted;

            // // vm.WidgetChanged = WidgetChanged;
            // //vm.selectId;
            // vm.getTncData =[];
            // vm.report=[];

            // var backend=tmxResource("PowerBIReports");
            // backend.getByAction('GetLatestReport',false).then( function(promise){
            //     vm.report=promise;
            //     var iframe = document.getElementById('iFrameEmbedReport');
            //     iframe.src = vm.report.data.Report.embedUrl;
            //     iframe.onload = postActionLoadReport;
            // });


            // vm.scope=$scope;

            // vm.go=function(){
            //     $state.go('Frame.LoanApplication');
            // }


            // Post the access token to the IFrame
            // function postActionLoadReport() {
            //     var m = {
            //         action: "loadReport",
            //         accessToken: vm.report.data.AccessToken,
            //     };
            //     message = JSON.stringify(m);
            //     iframe = document.getElementById('iFrameEmbedReport');
            //     iframe.contentWindow.postMessage(message, "*");;
            // }
            //#endregion

            //#region =========New Dashbard===========================

            //#region  Variables Initialization
            vm.largeBoxHeight = "100%";
            vm.largeBoxWidth = "50%";
            vm.smallBoxHeight = "48%";
            vm.smallBoxWidth = "24%";


            vm.loanApplicationsCount = {
                thisWeek: 0,
                thisMonth: 0,
                thisYear: 0
            };
            vm.accountApplicationsCount = {
                thisWeek: 0,
                thisMonth: 0,
                thisYear: 0
            };
            vm.defaultColors =  ["#e67300","#cc0000","#59b300","#1a53ff","#4d0000","#b3ff66","#666699","#bfbfbf","#ffb3e6","#ffb366","#001a66"];
            vm.barChartColors = ["#005c99"]
            //#endregion


            //#region  //////////Data Sources
            vm.BranchwiseApplications = "Dashboard/GetBranchwiseAccountApplications";
            vm.BranchwisePendingApplications = "Dashboard/GetPendingApplications";
            vm.BranchwiseChronicAccounts = "Dashboard/GetChronicAccounts";
            vm.BranchApplicationStatus = "Dashboard/GetBranchApplicationStatus";
            vm.BranchwiseRoleStatus = "Dashboard/GetBranchRoleStatus";
            vm.BranchwiseDescripancies = "Dashboard/GetBranchwiseDescripancies";
            vm.BranchCreditStatus = "Dashboard/BranchCreditStatus";
            vm.BranchwiseDiscrepantApps = "Dashboard/GetPendingDiscrepantApplications";
            vm.RoleWiseSessionHistory = "Dashboard/GetRoleWiseSessionHistory";
            vm.AppStatus = "Dashboard/GetUbankDashboardChart/AppStatus";
            vm.ApplicationsByProduct = "Dashboard/GetUbankDashboardChart/CountByProduct";
            vm.ApplicationsByProductBranch = "Dashboard/GetUbankDashboardChart/CountByProductBranch";
            vm.BranchwiseApplicationStatus = "Dashboard/GetUbankDashboardChart/BranchwiseAppStatus";
            vm.ApplicationStatusByDate = "Dashboard/GetUbankDashboardChart/ApplicationStatusByDate";
            vm.BranchTAT = "Dashboard/GetUbankDashboardChart/BranchTAT";

            //#endregion

            //#region     //////////Series
            vm.series_applications_piechart = [{
                field: 'Accounts',
                categoryField: 'BranchName',
                color: "#a0b0c0",
                padding: 10
            }];
            vm.role_wise_login_piechart = [{
                field: tmxUtility.formatColumnName('NoOfUsers'),
                categoryField: tmxUtility.formatColumnName('RoleName'),
                color: "#a0b0c0",
                padding: 10
            }];
            vm.series_pending_barchart = [{
                field: "Count",
                categoryField: "BranchName",
                name: "Number of Applications",
                color: "#1caf9a"
            }];
            vm.series_chronic_barchart = [{
                field: "Count",
                categoryField: "BranchName",
                name: "Number of Applications",
                color: "#1caf9a"
            }];
            vm.series_branch_status_barchart = [{
                field: "InProgress",
                categoryField: "BranchName",
                name: "In Progress",
            }, {
                field: "Completed",
                categoryField: "BranchName",
                name: "Completed",
            }, {
                field: "Rejected",
                categoryField: "BranchName",
                name: "Rejected",
            }];
            vm.series_branch_credit_status_barchart = [{
                field: "InProgress",
                categoryField: "BranchName",
                name: "In Progress",
                color: "#F9E811"
            }, {
                field: "Approved",
                categoryField: "BranchName",
                name: "Approved",
            }, {
                field: "Rejected",
                categoryField: "BranchName",
                name: "Rejected",
                color: "#FA461F"
            }];
            vm.series_branchwise_role_barchart = [{
                field: "InitialDraft",
                categoryField: "BranchName",
                name: "RM",
            }, {
                field: "DraftForReview",
                categoryField: "BranchName",
                name: "BM",
            }, {
                field: "DraftForReview2",
                categoryField: "BranchName",
                name: "AMD",
                color: "#4683af"
            }];
            vm.series_descripanices_barchart = [{
                field: "Count",
                categoryField: "BranchName",
                name: "Number of Applications",
            }];
            vm.series_application_product = [{
                field: tmxUtility.formatColumnName('ApplicationCount'),
                categoryField: tmxUtility.formatColumnName('ProductName'),
                name: "Number of Applications",
            }];
            vm.series_discrepant_applications_piechart = [{
                field: 'Count',
                categoryField: 'BranchName',
                color: "#a0b0c0",
                padding: 10
            }];
            vm.series_applications_status_piechart = [{
                field: tmxUtility.formatColumnName('ApplicationCount'),
                categoryField: tmxUtility.formatColumnName('Status'),
                padding: 10,
                name: "Number of Applications",
            }];
            vm.series_branch_product_applications = [{
                field: tmxUtility.formatColumnName("Agriculture"),
                categoryField: tmxUtility.formatColumnName("BranchName"),
                name: "Agriculture",
            }, {
                field: tmxUtility.formatColumnName("ApnaKarobar"),
                categoryField: tmxUtility.formatColumnName("BranchName"),
                name: "Apna Karobar",
            }, {
                field: tmxUtility.formatColumnName("GoldLoan"),
                categoryField: tmxUtility.formatColumnName("BranchName"),
                name: "Gold Loan",
            },{
                field: tmxUtility.formatColumnName("GoldMSME"),
                categoryField: tmxUtility.formatColumnName("BranchName"),
                name: "Gold MSME",
            // }, {
            //     field: tmxUtility.formatColumnName("L0AccountOpening"),
            //     categoryField: tmxUtility.formatColumnName("BranchName"),
            //     name: "L0 Account Opening",
            // }, {
            //     field: tmxUtility.formatColumnName("L2AccountOpening"),
            //     categoryField: tmxUtility.formatColumnName("BranchName"),
            //     name: "L2 Account Opening",
            // },{
            //     field: tmxUtility.formatColumnName("L2AgentOnBoarding"),
            //     categoryField: tmxUtility.formatColumnName("BranchName"),
            //     name: "L2 Agent OnBoarding",
            }, {
                field: tmxUtility.formatColumnName("Livestock"),
                categoryField: tmxUtility.formatColumnName("BranchName"),
                name: "Livestock",
            }, ];
            vm.series_application_state = [{
                field: tmxUtility.formatColumnName('ApplicationCount'),
                categoryField: tmxUtility.formatColumnName('State'),
                name: "Number of Applications",
            }];
            vm.series_branch_tat = [{
                field: tmxUtility.formatColumnName('Hours'),
                categoryField: tmxUtility.formatColumnName('Role'),
                name: "Time(Hours)",
            }];

            //#endregion
            //#region /////////Fiters
            vm.branch_pie_filter = {
                show: true,
                label:"Select Period",
                selectedValue: 'week',
                options: [{
                    VisibleValue: 'Week',
                    HiddenValue: 'week'
                }, {
                    VisibleValue: 'Month',
                    HiddenValue: 'month'
                }, {
                    VisibleValue: 'Year',
                    HiddenValue: 'year'
                }]
            };

            vm.branch_status_bar_filter = {
                show: true,
                label:"Select Period",
                selectedValue: 'day',
                options: [{
                    VisibleValue: 'Today',
                    HiddenValue: 'day'
                }, {
                    VisibleValue: 'Week',
                    HiddenValue: 'week'
                }, {
                    VisibleValue: 'Month',
                    HiddenValue: 'month'
                }, {
                    VisibleValue: 'Year',
                    HiddenValue: 'year'
                }, {
                    VisibleValue: 'To Date',
                    HiddenValue: 'todate'
                }]
            };

            vm.discrepant_applications_filter = {
                show: true,
                label:"Select Period",
                selectedValue: 'day',
                options: [{
                    VisibleValue: 'Today',
                    HiddenValue: 'day'
                }, {
                    VisibleValue: 'Week',
                    HiddenValue: 'week'
                }, {
                    VisibleValue: 'Month',
                    HiddenValue: 'month'
                }, {
                    VisibleValue: 'Year',
                    HiddenValue: 'year'
                }]
            };

            vm.branches_filter ={
                show:true,
                label:"Select Branch",
                selectedValue: -1,
                options:[{
                    VisibleValue:'All',
                    HiddenValue: -1
                }]
            };
            vm.application_status_branches_filter = Object.assign({}, vm.branches_filter);
            vm.applications_by_product_branches_filter = Object.assign({}, vm.branches_filter);
            //#endregion

            InitializePage();

            //#region  ------Local functions-----------

            function InitializePage() {
                GetCurrentUserApplications();
                GetLoggedInUserConfigurations();
                SetTenantSpecificVariables();
                checkDashboardTypeAndPermission();
            }           
            
            function SetTenantSpecificVariables(){
                if(vm.tenant == TMX_FINANCE_CONSTANTS.TENANTS.UBANK){
                    vm.isUbankTenant = true;
                    vm.showAccountAppSummary = false;
                    BranchService.getBranchesByUserCompany().then(function(response){
                        if(tmxUtility.exists(response,'data')){
                            response.data.forEach(x=> vm.branches_filter.options.push({
                                VisibleValue:x.BranchName,
                                HiddenValue:x.CompanyBranchId
                            }));
                        }
                    });
                }
                
            }
            function getBIReports() {
                DashboardService.GetBIReports().then(function (result) {
                    vm.report = result;
                    postActionLoadReport();
                }); 
            }
            function checkDashboardTypeAndPermission() {
                var dashboardPermision = tmxUtility.checkPermission('Dashboard Charts');
                if(dashboardPermision==true) { 
                    vm.dashboardType = tmxUtility.getConfigurationValue(LoggedInUserConfigurations,'DASHBOARD_TYPE',false);
                    if(vm.dashboardType==TMX_FINANCE_CONSTANTS.DASHBOARD_TYPES.POWERBI) {
                        getBIReports();  
                    }
                    else vm.dashboardType = TMX_FINANCE_CONSTANTS.DASHBOARD_TYPES.ProductDashboard;
                }
            }
            function postActionLoadReport() {
                if (vm.report.data.Reports != undefined) { 
                    var models = window['powerbi-client'].models;
    
                    var config = {
                        type: 'report',
                        tokenType: models.TokenType.Embed,
                        accessToken: vm.report.data.AccessToken,
                        embedUrl: vm.report.data.Reports[0].embedUrl,
                        id: vm.report.data.Reports[0].id,
                        permissions: models.Permissions.All,
                        settings: {
                            filterPaneEnabled: true,
                            navContentPaneEnabled: true
                        }
                    };
    
                    var reportContainer = $('#reportContainer')[0];
                    try{
                        powerbi.embed(reportContainer, config);
                    }
                    catch(e){
                        console.log(e);
                    }
                    
                }
            }
            
            function GetCurrentUserApplications() {
                DashboardService.getCurrentUserApplications().then(function (result) {
                    var currentMonth = new Date().getMonth() + 1; // Month is 0 indexed in Javascript 
                    result.forEach(function (x) {
                        if (x.ApplicationType == 'Account' || x.APPLICATIONTYPE == 'Account') {
                            vm.accountApplicationsCount.thisWeek = Boolean(APP_CONSTANTS.isOracleDB) ? x.WEEKCOUNT : x.WeekCount;
                            vm.accountApplicationsCount.thisYear += Boolean(APP_CONSTANTS.isOracleDB) ? x.COUNT : x.Count;
                            if (x.Month == currentMonth || x.MONTH == currentMonth) {
                                vm.accountApplicationsCount.thisMonth = Boolean(APP_CONSTANTS.isOracleDB) ? x.COUNT : x.Count;
                            }
                            vm.accountApplicationsCount.total = Boolean(APP_CONSTANTS.isOracleDB) ? x.TOTALCOUNT : x.TotalCount;
                        }
                        else {
                            vm.loanApplicationsCount.thisWeek = Boolean(APP_CONSTANTS.isOracleDB) ? x.WEEKCOUNT : x.WeekCount;
                            vm.loanApplicationsCount.thisYear += Boolean(APP_CONSTANTS.isOracleDB) ? x.COUNT : x.Count;
                            if (x.Month == currentMonth || x.MONTH == currentMonth) {
                                vm.loanApplicationsCount.thisMonth = Boolean(APP_CONSTANTS.isOracleDB) ? x.COUNT : x.Count;
                            }
                            vm.loanApplicationsCount.total = Boolean(APP_CONSTANTS.isOracleDB) ? x.TOTALCOUNT : x.TotalCount;
                        }
                    });
                });
            }

            function ShowDetailsDialog(data, dialogIdentifier) {
                $mdDialog.show({
                    controller: ['$mdDialog', '$scope', 'data', 'identifier', detailsDialogController],
                    locals: {
                        data: data,
                        identifier: dialogIdentifier
                    },
                    templateUrl: 'app/private/dashboard/details-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
            }

            function GetLoggedInUserConfigurations() {
                var configurations = $scope.$parent.PrivateCtrl.Configurations; //cacheStore.get("Configurations");
                vm.tenant = tmxUtility.getConfigurationValue(configurations, 'INTEGRATION_TENANT').toLowerCase();
            }


            //#endregion

            //#region ------Scope functions-------------

            vm.OnPendingAppClick = function (e, data) {
                ShowDetailsDialog(data, 'PendingApps');
            }

            vm.OnChronicAccountsClick = function (e, data) {
                ShowDetailsDialog(data, 'ChronicApps');
            }
            vm.refreshDashboard = function() {
                cacheStore.remove('PowerBIReportModel');
                getBIReports();
            }
            //#endregion

            //#region ---- Child Controllers

            function detailsDialogController($mdDialog, $scope, data, identifier) {
                $scope.vm = {};
                $scope.vm.data = data;
                $scope.vm.identifier = {
                    PendingApps: false,
                    ChronicApps: false
                };
                $scope.vm.dialogTitle = 'Details';
                $scope.vm.dataLoading = true;
                $scope.vm.Applications = [];

                (function SetDialogType() {
                    if (identifier == 'PendingApps') {
                        $scope.vm.identifier.PendingApps = true;
                    }
                    else if (identifier == 'ChronicApps') {
                        $scope.vm.identifier.ChronicApps = true;
                    }
                })();

                (function InitializeDialog() {
                    if ($scope.vm.identifier.PendingApps) {
                        $scope.vm.dialogTitle = 'Pending Applications';
                        LoadPendingApps();
                    }
                    else if ($scope.vm.identifier.ChronicApps) {
                        $scope.vm.dialogTitle = 'Chronic Application Details';
                        LoadChronicApps();
                    }
                })();

                $scope.ok = function () {
                    $mdDialog.hide();
                }

                $scope.cancel = function () {
                    $mdDialog.hide();
                };

                function LoadPendingApps() {
                    $scope.vm.dataLoading = true;
                    DashboardService.GetPendingAppDetails(data.BranchId).then(function (response) {
                        $scope.vm.dataLoading = false;
                        $scope.vm.Applications = response;
                    },
                    function () {
                        $scope.vm.dataLoading = false;
                        $scope.vm.Applications = [];
                    });
                }

                function LoadChronicApps() {
                    $scope.vm.dataLoading = true;
                    DashboardService.GetChronicAppDetails(data.BranchId).then(function (response) {
                        $scope.vm.dataLoading = false;
                        $scope.vm.Applications = response;
                    },
                    function () {
                        $scope.vm.dataLoading = false;
                        $scope.vm.Applications = [];
                    });
                }

            }
            //#endregion
            //#endregion

        }]);

})();